var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98916 8.00049L15.5556 2.43408C15.8197 2.17037 15.9683 1.81251 15.9687 1.43923C15.969 1.06595 15.821 0.707831 15.5573 0.44365C15.2936 0.17947 14.9357 0.0308697 14.5625 0.0305401C14.1892 0.0302104 13.8311 0.178178 13.5669 0.441893L8.00049 6.0083L2.43408 0.441893C2.1699 0.177712 1.81159 0.0292969 1.43799 0.0292969C1.06438 0.0292969 0.706073 0.177712 0.441893 0.441893C0.177712 0.706073 0.0292969 1.06438 0.0292969 1.43799C0.0292969 1.81159 0.177712 2.1699 0.441893 2.43408L6.0083 8.00049L0.441893 13.5669C0.177712 13.8311 0.0292969 14.1894 0.0292969 14.563C0.0292969 14.9366 0.177712 15.2949 0.441893 15.5591C0.706073 15.8233 1.06438 15.9717 1.43799 15.9717C1.81159 15.9717 2.1699 15.8233 2.43408 15.5591L8.00049 9.99267L13.5669 15.5591C13.8311 15.8233 14.1894 15.9717 14.563 15.9717C14.9366 15.9717 15.2949 15.8233 15.5591 15.5591C15.8233 15.2949 15.9717 14.9366 15.9717 14.563C15.9717 14.1894 15.8233 13.8311 15.5591 13.5669L9.98916 8.00049Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f07e0ebe9a3459bd2244017a384bc856.svg";
export { ForwardRef as ReactComponent };